"use client"
/* */
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import 'react';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import * as Aria from 'react-aria-components';
import clsx from 'clsx';
import styles from './Slider.module.scss.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { Button } from '../Button/Button.mjs';
import '@tabler/icons-react';
import '../Icon/Icon.mjs';
import { IconMinus } from '../Icon/components/icons/IconMinus.mjs';
import { IconPlus } from '../Icon/components/icons/IconPlus.mjs';
import locales from '../../../../_virtual/_.locale.json@3ed2dc50f997451bdd85a713c54e1025.mjs';
import { useLocalizedStringFormatter } from 'react-aria';

const Slider = flowComponent("Slider", (props) => {
  const {
    className,
    children,
    name,
    isDisabled,
    defaultValue,
    showInitialMarker,
    ...rest
  } = props;
  const rootClassName = clsx(
    styles.slider,
    isDisabled && styles.disabled,
    className
  );
  const stringFormatter = useLocalizedStringFormatter(locales);
  const propsContext = {
    Label: {
      unstyled: true
    }
  };
  return /* @__PURE__ */ jsxs(
    Aria.Slider,
    {
      className: rootClassName,
      isDisabled,
      defaultValue,
      ...rest,
      children: [
        /* @__PURE__ */ jsxs("div", { className: styles.text, children: [
          /* @__PURE__ */ jsx(Aria.SliderOutput, { className: styles.value }),
          /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children })
        ] }),
        /* @__PURE__ */ jsx(Aria.SliderTrack, { className: styles.track, children: ({ state }) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              onPress: () => state.decrementThumb(0),
              "aria-label": stringFormatter.format("slider.decrement"),
              variant: "plain",
              color: "secondary",
              className: styles.decrement,
              isDisabled,
              excludeFromTabOrder: true,
              children: /* @__PURE__ */ jsx(IconMinus, {})
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              onPress: () => state.incrementThumb(0),
              "aria-label": stringFormatter.format("slider.increment"),
              variant: "plain",
              color: "secondary",
              className: styles.increment,
              isDisabled,
              excludeFromTabOrder: true,
              children: /* @__PURE__ */ jsx(IconPlus, {})
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: styles.fill,
              style: { width: state.getThumbPercent(0) * 100 + "%" }
            }
          ),
          showInitialMarker && defaultValue && typeof defaultValue === "number" && /* @__PURE__ */ jsx(
            "div",
            {
              className: styles.initialMarker,
              style: {
                left: `calc(${state.getValuePercent(defaultValue) * 100}% - 2px)`
              }
            }
          ),
          /* @__PURE__ */ jsx(Aria.SliderThumb, { name, className: styles.handle })
        ] }) })
      ]
    }
  );
});

export { Slider, Slider as default };
//# sourceMappingURL=Slider.mjs.map
